import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {RESPONSE} from "../../../express.tokens";
import {Response} from "express";
import {Router} from "@angular/router";
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private router = inject(Router);
  private platformId = inject<Object>(PLATFORM_ID);
  private response = inject<Response>(RESPONSE, { optional: true });


  redirect(location: string, history = false, openNewWindow = false) {
    const hasProtocol = /^https?:\/\//i.test(location);
    const isExternal = hasProtocol || history;

    if (isExternal && isPlatformBrowser(this.platformId)) {
      const finalUrl = hasProtocol ? location : 'https://' + location;
      if (openNewWindow) {
        window.open(finalUrl, '_blank');
      } else {
        window.location.href = finalUrl;
      }
      return;
    }

    this.router.navigateByUrl(location);
  }
}
